export { default as Shortcut } from './Shortcut';
export { default as ShortcutTable } from './ShortcutTable';
